











































import UserForm from '@/components/user/UserForm.vue';
import UserUtils, { User } from '@/utils/UserUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { UserForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      delete: boolean;
      errors?: any[];
    };
    item?: Partial<User>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        delete: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    try {
      this.item = await UserUtils.api.get(parseInt(this.$route.params?.id));
      (this.$refs.form as any).resetValidation();
    } catch (error: any) {
      if (error.response.status === 404) {
        // TODO: not found
      }
    }
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();
          this.item = await UserUtils.api.update(this.item);
          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.edit', [this.$tc('user.label')]),
            type: 'success',
          });
          this.$router.push(this.$route.meta.header.route);
        } catch (error: any) {
          this.$toast.push({
            text: this.$t('error.edit', [this.$tc('user.label')]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },

    async handleDelete() {
      try {
        this.state.errors = undefined;
        this.state.delete = true;
        await UserUtils.api.remove(parseInt(this.$route.params?.id));
        this.$toast.push({
          text: this.$t('success.delete', [this.$tc('user.label')]),
          type: 'success',
        });
        this.$router.replace({ name: 'user-list' });
      } catch (error: any) {
        this.$toast.push({
          text: this.$t('error.delete', [this.$tc('user.label')]),
          type: 'error',
        });
        this.state.errors = error; // TODO: handle errors
      } finally {
        this.state.delete = false;
      }
    },
  },
});
